import { render, staticRenderFns } from "./ItemsFilter.vue?vue&type=template&id=2ec69acc&"
import script from "./ItemsFilter.vue?vue&type=script&lang=js&"
export * from "./ItemsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports